module.exports = __webpack_public_path__ + "static/media/postman.2e25ffef.png";